import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Tools from "./pages/Tools";
import DataSolutions from "./pages/DataSolutions";
import Training from "./pages/Training";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Downloads from "./pages/Downloads";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/tools" element={<Tools />} />
            <Route path="/data" element={<DataSolutions />} />
            <Route path="/training" element={<Training />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/downloads" element={<Downloads />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;